export const allTypes = [
  {
    key: "keypoints",
    value: "핵심정리",
  },
  {
    key: "reading",
    value: "지문읽기",
  },
  {
    key: "direct_translation",
    value: "직독직해",
    // 학생이 거치는 순서. student 의 DirectTranslationPage.jsx 의 MODE_LIST 와 같아야 한다.
    options: [
      {
        key: "listening",
        value: "듣기",
      },
      {
        key: "fluency",
        value: "유창성",
      },
      {
        key: "interpretation",
        value: "통역",
      },
    ],
    // 한 번에 얼마씩 읽힐지. 학생은 못 바꾼다.
    readingUnits: [
      { key: "sentence", value: "문장 단위" },
      { key: "chunk", value: "끊어읽기 단위" },
    ],
    // 읽어 주는 속도. 1 이 브라우저 기본이다. **1.4 까지 연다.** 듣기에 익은
    // 아이에게는 1.2 도 느려서 지루해한다.
    speechRates: [
      { key: 0.8, value: "느리게 0.8배" },
      { key: 1, value: "보통 1배" },
      { key: 1.2, value: "빠르게 1.2배" },
      { key: 1.4, value: "더 빠르게 1.4배" },
    ],
    // 몇 점부터 통과로 볼지. 유창성과 통역이 각각 따로 간다.
    // 0 은 점수와 상관없이 넘어가게 두는 것이다.
    passingScores: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  },
  {
    key: "words",
    value: "단어학습",
  },
  {
    key: "syntax_analysis",
    value: "구문분석",
    levels: [
      {
        key: "elementary",
        value: "하",
        text: "주어, 동사, 목적어, 보어(SVOC)를 구분하는 문제입니다. 각 문장성분의 범위는 주어집니다.",
      },
      {
        key: "intermediate",
        value: "중",
        text: "주어, 동사, 목적어, 보어(SVOC)를 구분하는 문제입니다. 각 문장성분의 범위는 직접 지정해야 합니다.",
      },
      {
        key: "advanced",
        value: "상",
        text: "전치사구, 부사구, SVOC를 비롯한 모든 문장 성분을 구분하는 문제입니다. 각 문장성분의 범위는 직접 지정해야 합니다.",
      },
    ],
  },
  {
    key: "flow",
    value: "흐름정리",
  },
  {
    key: "sentence_test",
    value: "문장학습",
    options: [
      {
        key: "kor_blank",
        value: "한글 해석",
      },
      {
        key: "eng_blank",
        value: "영어 빈칸",
      },
      {
        key: "eng_blank_random",
        value: "영어 랜덤 빈칸",
      },
      {
        key: "eng_scramble",
        value: "스크램블",
      },
    ],
  },
];
